import { useQueryApplication } from 'src/graphqlhooks';
import { useRequestGQLQuery } from './useGraphQLQuery';

export const DESCRIBE_DOCUMENTS_BY_TASK_ID = `query getDocumentPointer($objectMeta: jsonb) {
  document_pointers(where: {object_meta: {_contains: $objectMeta}}) {
    id
    object_meta
    type_meta
    updated_at
    created_at
    metadata
    remote_bucket
    remote_filename
    remote_folder
  }
}`;

export const GQLGetDocumentPointerByTaskId = (id: any) => {
  const { data, loading, refetch } = useQueryApplication(DESCRIBE_DOCUMENTS_BY_TASK_ID, {
    variables: {
      objectMeta: {
        owner_references: [
          {
            uid: id,
          },
        ],
      },
    },
  });
  return { data, loading, refetch };
};


export const GQL_GLOBAL_DOCUMENT_ARTIFACTS_MINIMAL = `global_document_artifacts {
  category
  artifact
}`


export const GQL_GLOBAL_DOCUMENT_ARTIFACTS = `global_document_artifacts {
  id
  object_meta
  type_meta
  category
  artifact
  description
  child_of
  usages
  updated_at
  created_at
}`

export const CREATE_OR_UPDATE_DOCUMENT_ARTIFACTS = `mutation createOrUpdateDocumentArtifacts($data: [global_document_artifacts_insert_input!]!) {
  insert_global_document_artifacts(
    objects: $data,
    on_conflict: {
      constraint: global_document_artifacts_pkey, 
      update_columns: [
        object_meta,
        type_meta,
        category,
        artifact,
        description,
        child_of,
        usages,
        updated_at
      ]
    }
  ) {
      returning {
        id
        object_meta
        type_meta
        category
        artifact
        description
        child_of
        usages
        updated_at
        created_at
      }
    }
  }`


export const DELETE_DOCUMENT_ARTIFACTS = `mutation deleteDocumentArtifacts($uid: bigint) {
  delete_global_document_artifacts(where: {id: {_eq: $uid} }) {
  affected_rows
  }
}`

const GET_DOCUMENT_ARTIFACTS = `query getGlobalDocumentArtifacts {
 ${GQL_GLOBAL_DOCUMENT_ARTIFACTS}
}`;


const UPSERT_DOCUMENT_ACCESS_CONTROLS = `mutation upsertDocumentAccessControls($documentAccesss: [document_access_controls_insert_input]!) {
  insert_document_access_controls(
    objects: $documentAccesss,
    on_conflict: {
      constraint: document_access_controls_pkey,
      update_columns: [access_controls, metadata, permitted_access, updated_at, object_meta]
    }
  ) {
    returning {
      id
      loantype
      persona
      access_controls
      metadata
      permitted_access
      folder
      type_meta
      object_meta
      created_at
      updated_at
    }
  }
}`

export const GQLUpsertDocumentArtifacts = (documentAccesss: any) => {
  return useRequestGQLQuery(UPSERT_DOCUMENT_ACCESS_CONTROLS, {
    documentAccesss
  });
};


export const GQLGetGlobalDocumentArtifacts = async () => {
  const result = useRequestGQLQuery(GET_DOCUMENT_ARTIFACTS, {});
  return result;
};

export const GQLDocsByTaskId = (id: any, dataCheck: any) => {
  return dataCheck({ variables: id })
};